<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-3xl mx-auto bg-base-100 p-8 md:p-12 rounded-3xl shadow-xl animate-fade-in-up">
      
      <h1 class="text-3xl md:text-4xl font-extrabold text-base-content mb-8 border-b border-base-200 pb-4">Terms of Use</h1>
      
      <div class="space-y-6 text-base-content/80 leading-relaxed">
        <p><strong>Last Updated: July 2026</strong></p>
        
        <h2 class="text-xl font-bold text-primary mt-8 mb-2">1. Acceptance of Terms</h2>
        <p>By accessing and using Aanza's restaurant management platform, QR ordering services, and digital menu features, you agree to comply with and be bound by these Terms of Use.</p>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">2. Description of Service</h2>
        <p>Aanza provides a Software as a Service (SaaS) solution enabling restaurant owners to manage operations, including stock and employee management, and offering users an interactive QR code-based ordering experience.</p>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">3. User Responsibilities</h2>
        <p>Users of the QR menu agree to use the service for its intended purpose of viewing menus and placing orders. Restaurant owners are responsible for maintaining accurate stock and menu information within the Aanza dashboard.</p>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">4. Limitation of Liability</h2>
        <p>Aanza is not liable for any discrepancies in restaurant stock, mispriced menu items, or disruptions in restaurant operations. Our platform is provided "as is" to facilitate better management and dining experiences.</p>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
